// Every image upload endpoint — docs/real-estate/be/10-api-reference.md
// §A4. Every one of these takes a real File/Blob and multipart-encodes it;
// components pass the File straight from an <input type="file"> or a drop
// handler, this is the only layer that touches FormData.
import { request } from './http';

function fileForm(file, extra) {
  const form = new FormData();
  form.append('file', file);
  Object.entries(extra || {}).forEach(([key, value]) =>
    form.append(key, value)
  );
  return form;
}

export function setCover(pid, file) {
  return request({
    method: 'put',
    path: `/properties/${pid}/cover`,
    data: fileForm(file),
    isMultipart: true,
  });
}
export function deleteCover(pid) {
  return request({ method: 'delete', path: `/properties/${pid}/cover` });
}

// A project's brochures (docs/real-estate/be/13-fe-update-2026-09-30.md
// §1): any number, each PDF, JPG or PNG (no WebP, unlike every other upload
// here) with an optional title of up to 100 characters. A new one is
// appended last.
export function addBrochure(pid, file, title) {
  return request({
    method: 'post',
    path: `/properties/${pid}/brochures`,
    data: fileForm(file, title ? { title } : undefined),
    isMultipart: true,
  });
}
// `title` null (or blank) clears it.
export function updateBrochureTitle(pid, brochureId, title) {
  return request({
    method: 'patch',
    path: `/properties/${pid}/brochures/${brochureId}`,
    data: { title },
  });
}
// Every brochure id, exactly once, in the new order.
export function reorderBrochures(pid, brochureIds) {
  return request({
    method: 'put',
    path: `/properties/${pid}/brochures/order`,
    data: { brochure_ids: brochureIds },
  });
}
export function deleteBrochure(pid, brochureId) {
  return request({
    method: 'delete',
    path: `/properties/${pid}/brochures/${brochureId}`,
  });
}

export function addGalleryImage(pid, file, caption) {
  return request({
    method: 'post',
    path: `/properties/${pid}/gallery`,
    data: fileForm(file, caption ? { caption } : undefined),
    isMultipart: true,
  });
}

export function setFeatureIcon(pid, featureId, file) {
  return request({
    method: 'put',
    path: `/properties/${pid}/features/${featureId}/icon`,
    data: fileForm(file),
    isMultipart: true,
  });
}
export function deleteFeatureIcon(pid, featureId) {
  return request({
    method: 'delete',
    path: `/properties/${pid}/features/${featureId}/icon`,
  });
}

export function setNearbyIcon(pid, nearbyId, file) {
  return request({
    method: 'put',
    path: `/properties/${pid}/nearby/${nearbyId}/icon`,
    data: fileForm(file),
    isMultipart: true,
  });
}
export function deleteNearbyIcon(pid, nearbyId) {
  return request({
    method: 'delete',
    path: `/properties/${pid}/nearby/${nearbyId}/icon`,
  });
}

export function setUnitLayout(pid, unitId, file) {
  return request({
    method: 'put',
    path: `/properties/${pid}/units/${unitId}/layout`,
    data: fileForm(file),
    isMultipart: true,
  });
}
export function deleteUnitLayout(pid, unitId) {
  return request({
    method: 'delete',
    path: `/properties/${pid}/units/${unitId}/layout`,
  });
}

export function setUnitImage(pid, unitId, file) {
  return request({
    method: 'put',
    path: `/properties/${pid}/units/${unitId}/image`,
    data: fileForm(file),
    isMultipart: true,
  });
}
export function deleteUnitImage(pid, unitId) {
  return request({
    method: 'delete',
    path: `/properties/${pid}/units/${unitId}/image`,
  });
}
